import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
export var NotBrandNorRetailerMessage = function NotBrandNorRetailerMessage(_ref) {
  var visible = _ref.visible;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "RTbSpK",
    defaultMessage: [{
      "type": 0,
      "value": "Als je een merk of retailer bent, kies dan een van de bovenstaande opties om binnen 24 uur antwoord te krijgen. Als je geen merk of retailer bent, stuur ons dan een e-mail via external-requests@faire.com."
    }]
  }));
};